import { useState } from "react";

// Airline logo mapping - using airline codes to get logo URLs
// Using multiple airline logo API services for better reliability

// Common airline codes and their logo URLs
export const getAirlineLogo = (airlineCode, airlineName = "") => {
  if (!airlineCode) return null;

  const code = airlineCode.toUpperCase().trim();

  // Multiple logo sources for better reliability
  const logoUrls = [
    `https://logos.skyscnr.com/images/airlines/fact_sheets/${code.toLowerCase()}.png`,
    `https://www.gstatic.com/flights/airline_logos/70px/${code.toLowerCase()}.png`,
    `https://content.airhex.com/content/logos/airlines_${code}_50_50_r.png`,
    `https://d1ufw0nild2mi8.cloudfront.net/images/airlines/V2/${code.toLowerCase()}/@2x.png`,
  ];

  return {
    urls: logoUrls,
    code: code,
    name: airlineName,
  };
};

// Helper to get airline logo image component
const AirlineLogo = ({ airlineCode, airlineName, className = "w-12 h-12" }) => {
  const logo = getAirlineLogo(airlineCode, airlineName);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showFallback, setShowFallback] = useState(false);

  if (!logo) {
    return (
      <div className={`${className} bg-gray-200 rounded-lg flex items-center justify-center border border-gray-300`}>
        <span className="text-xs font-bold text-gray-600">{airlineCode || "N/A"}</span>
      </div>
    );
  }

  const handleImageError = () => {
    if (currentImageIndex < logo.urls.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else {
      setShowFallback(true);
    }
  };

  if (showFallback) {
    return (
      <div className={`${className} bg-gradient-to-br from-blue-100 to-indigo-100 rounded-lg flex items-center justify-center border border-gray-300 shadow-sm`}>
        <span className="text-xs font-bold text-gray-700">{logo.code}</span>
      </div>
    );
  }

  return (
    <div className={`${className} relative bg-white rounded-lg border border-gray-200 p-1 shadow-sm`}>
      <img
        src={logo.urls[currentImageIndex]}
        alt={airlineName || airlineCode}
        className="w-full h-full object-contain"
        onError={handleImageError}
        loading="lazy"
      />
    </div>
  );
};

export default AirlineLogo;
